import { getEmployeesOverview } from "@/api/activities.api";
import { useAuthStore } from "@/store/useAuthStore";
import { useDateStore } from "@/store/useDateStore";
import { useQuery } from "@tanstack/react-query";

export function useEmployeesOverview() {
  const { startDate } = useDateStore();
  const currentOrgId = useAuthStore((s) => s.currentOrgId);

  return useQuery({
    queryKey: ["employees-overview", startDate, currentOrgId],
    queryFn: () => getEmployeesOverview(startDate),
    refetchInterval: 60000,
    staleTime: 30000,
  });
}
